import { pageLoadingOn } from '../utilities';
import { VirtualForm } from './paymentsUtils';

export class GooglePayHandler {
  /** @var { number } */
  static totalPrice = 0;
  /**
   * @var { number }
   */
  gatewayId;
  /**
   * @var { number }
   */
  paymentId;
  /**
   * @var { string }
   */
  paymentType;
  /**
   * @var { string }
   */
  merchantId;
  /**
   * @var { Element }
   */
  container;
  /**
   * @var {{ environment: 'TEST'|'PRODUCTION', gatewayMerchantId: string }}
   */
  options;

  googlePayConfiguration;
  /**
   * Adiciona o script da GooglePay e inicia
   * 
   * @param { Element } container 
   * @param { int } paymentId 
   * @param { int } gatewayId
   * @param { string } merchantId 
   * @param { { environment: 'TEST'|'PRODUCTION', gatewayMerchantId: ?string } } options
   */
  constructor(container, paymentId, gatewayId, paymentType, merchantId, options) {
    this.container = container;
    this.paymentId = paymentId;
    this.gatewayId = gatewayId;
    this.paymentType = paymentType;
    this.merchantId = merchantId;
    this.options = options;
    this.setConfig();
  }

  /**
   * Seta as configurações corretas de pagamento
   */
  setConfig() {
    this.googlePayConfiguration = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [],
    }

    if (this.gatewayId = 34) {
      const tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          'gateway': 'cielo',
          'gatewayMerchantId': this.options?.gatewayMerchantId ?? 'b16538f1-ab0a-41b5-a91b-b18a1357e435',
          // 'gateway': 'example',
          // 'gatewayMerchantId': 'gatewayMerchantId'
        }
      };
      const cardPaymentMethods = {
        type: 'CARD',
        tokenizationSpecification,
        parameters: {
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX", "DISCOVER", "JCB"]
        }
      };
      this.googlePayConfiguration.allowedPaymentMethods.push(cardPaymentMethods);
    }
  }

  /**
   * Retorna a configuração usado na API do google
   */
  getConfig() {
    return this.googlePayConfiguration;
  }
}

/**
 * Executa quando carrega o script da google pay
 * 
 * @param { GooglePayHandler } googlePayHandler
 */
const onGooglePayLoaded = (googlePayHandler) => {
  const client = new google.payments.api.PaymentsClient({ environment: googlePayHandler.options?.environment ?? 'TEST'});
  client.isReadyToPay(googlePayHandler.getConfig())
    .then(response => {
      if (!response.result) return Promise.reject()
      const button = client.createButton({
        onClick: () => onGooglePayClick(googlePayHandler, client),
        buttonColor: 'default',
        buttonType: 'buy',
        buttonRadius: 55,
      });
      googlePayHandler.container.appendChild(button);
    })
}

/**
 * Executa quando carrega o script da google pay
 * 
 * @param { GooglePayHandler } googlePayHandler
 * @param { google.payments.api.PaymentsClient } client
 */
const onGooglePayClick = (googlePayHandler, client) => {
  const paymentDataRequest = { ...googlePayHandler.getConfig() };
  paymentDataRequest.transactionInfo = {
    totalPriceStatus: 'FINAL',
    totalPrice: GooglePayHandler.totalPrice.toFixed(2),
    currencyCode: 'BRL',
    countryCode: 'BR'
  };

  if (googlePayHandler.options.environment === 'PRODUCTION') {
    paymentDataRequest.merchantInfo = {
      merchantId: googlePayHandler.merchantId,
    }
  }
  console.log(JSON.stringify(paymentDataRequest));
  client.loadPaymentData(paymentDataRequest)
    .then( paymentData => {
      // if using gateway tokenization, pass this token without modification
      if (!paymentData.paymentMethodData.tokenizationData.token) {
        return Promise.reject("Token não retornado");
      }

      const form = new VirtualForm('form-payment-google', '', 'POST');
      form.addInput('checkout', '1');
      form.addInput('nparcels', '1');
      form.addInput('paymentId', googlePayHandler.paymentId);
      form.addInput('gateway', googlePayHandler.gatewayId);
      form.addInput('payment_type', googlePayHandler.paymentType);
      form.addInput('walletToken', paymentData.paymentMethodData.tokenizationData.token);
      googlePayHandler.container.appendChild(form.getForm());

      pageLoadingOn();
      
      form.getForm().submit();

    }).catch(function(err) {
      // show error in developer console for debugging
      console.error(err);
    });
}

/**
 * Adiciona o script da GooglePay e inicia
 * 
 * @param { GooglePayHandler } googlePayHandler
 */
export const init = (googlePayHandler) => {
  const hasScript = document.querySelector("script#googlepay");
  if (hasScript) {
    onGooglePayLoaded(googlePayHandler);
    return;
  }
  const script = document.createElement("script");
  script.src = "https://pay.google.com/gp/p/js/pay.js";
  script.id = "googlepay";
  script.onload = () => onGooglePayLoaded(googlePayHandler);
  script.onerror = () => console.log('Erro ao carregar o script do GooglePay');
  document.head.appendChild(script);
}